// extracted by mini-css-extract-plugin
export var noSpinners = "_o0-6";
export var percentageInput = "_o0-7";
export var variantColor1 = "_o0-0";
export var variantColor2 = "_o0-1";
export var variantColor3 = "_o0-2";
export var variantColor4 = "_o0-3";
export var variantColor5 = "_o0-4";
export var variantColor6 = "_o0-5";